$(document).ready(function($) {

    function animateStats(element) {
        if (!element.hasClass('animated')) {
            element.addClass('animated');
            element.find('.stat-number').each(function(){
                var $this = $(this);
                $this.attr('data-count', $this.text());
                //see if this value contains a + or - sign
                if ($this.text().indexOf('+') >= 0) {
                    $this.attr('data-count', $this.text().replace('+', ''));
                    //check if the sign is at the beginning of the string or the end
                    if ($this.text().indexOf('+') == 0) {
                        $this.attr('prepend', '+');
                    } else {
                        $this.attr('append', '+');
                    }
                }
                if ($this.text().indexOf('-') >= 0) {
                    $this.attr('data-count', $this.text().replace('-', ''));
                    //check if the sign is at the beginning of the string or the end
                    if ($this.text().indexOf('-') == 0) {
                        $this.attr('prepend', '-');
                    } else {
                        $this.attr('append', '-');
                    }
                }
                //see if this value contains a % sign
                if ($this.text().indexOf('%') >= 0) {
                    $this.attr('data-count', $this.text().replace('%', ''));
                    $this.attr('append', '%');
                }
                if (!isNaN($this.attr('data-count'))) {
                    var countTo = $this.attr('data-count');
                    $({ countNum: 0}).animate({
                        countNum: countTo
                    },
                    {
                        duration: 2000,
                        easing:'linear',
                        step: function() {
                            $this.text(Math.floor(this.countNum));
                            if ($this.attr('prepend')) {
                                $this.text($this.attr('prepend') + $this.text());
                            }
                            if ($this.attr('append')) {
                                $this.text($this.text() + $this.attr('append'));
                            }
                        },
                        complete: function() {
                            $this.text(this.countNum);
                            if ($this.attr('prepend')) {
                                $this.text($this.attr('prepend') + $this.text());
                            }
                            if ($this.attr('append')) {
                                $this.text($this.text() + $this.attr('append'));
                            }
                        }
                    });
                }
            });
        }
    }

    var elementToShow = $('.statistics.has-scroll-animation');
    var windowHeight = $(window).height();
    var offset = 100;
    elementToShow.each(function(){
        var $this = $(this);
        var top = $this.offset().top;
        var scroll = $(window).scrollTop();
        if (scroll + windowHeight >= top + offset) {
            animateStats($this);
        }
    });

    $(window).on('scroll', function(e){
        var scroll = $(window).scrollTop();
        var elementToShow = $('.statistics.has-scroll-animation');
        var windowHeight = $(window).height();
        var offset = 100;
        elementToShow.each(function(){
            var $this = $(this);
            var top = $this.offset().top;
            if (scroll + windowHeight > top + offset) {
                animateStats($this);
            }
        });
    });
});